/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { formatDependencies } from './dependenciesFormat.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createOct } from '../../factoriesAny.js';
export var octDependencies = {
  formatDependencies,
  typedDependencies,
  createOct
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesOct.generated.js
// module id = 1427
// module chunks = 2